import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Ariakit from '@ariakit/react';
import { cloneElement, forwardRef } from 'react';
import { Dialog } from '../';
import { LmfAnalyticsProvider, useLmfAnalyticsOnOpen } from '../../Analytics/LmfAnalyticsProvider';
import * as Styles from './styles';
export const Modal = forwardRef(function Modal({ analyticsTitle, header, footer, content = _jsx(Dialog.Content, {}), backdrop = _jsx(Dialog.Backdrop, {}), children, fullscreenMobile = false, ...rest }, ref) {
    const dialogContext = Ariakit.useDialogContext();
    const dialogState = Ariakit.useStoreState(dialogContext);
    useLmfAnalyticsOnOpen({
        isOpen: dialogState?.open,
        element: 'dialog',
        variant: 'modal',
        label: analyticsTitle,
    });
    return (_jsx(LmfAnalyticsProvider, { title: analyticsTitle, children: _jsxs(Styles.Modal, { modal: true, unmountOnHide: true, backdrop: backdrop, "$fullscreenMobile": fullscreenMobile, render: props => (_jsx(Styles.DialogContainer, { "$fullscreenMobile": fullscreenMobile, children: _jsx("div", { ...props }) })), ...rest, ref: ref, children: [header && _jsx(Styles.InheritedRadius, { "$dir": 'top', children: header }), cloneElement(content, { children }), footer && _jsx(Styles.InheritedRadius, { "$dir": 'bottom', children: footer })] }) }));
});
//# sourceMappingURL=index.js.map